// Bandera emoji por selección. Para el hincha: identifica de un vistazo.
// Placeholders de llave ("2A", "W74") caen al fallback ⚽.

const FLAGS: Record<string, string> = {
  Algeria: '🇩🇿',
  Argentina: '🇦🇷',
  Australia: '🇦🇺',
  Austria: '🇦🇹',
  Belgium: '🇧🇪',
  'Bosnia & Herzegovina': '🇧🇦',
  Brazil: '🇧🇷',
  Canada: '🇨🇦',
  'Cape Verde': '🇨🇻',
  Colombia: '🇨🇴',
  Croatia: '🇭🇷',
  'Curaçao': '🇨🇼',
  'Czech Republic': '🇨🇿',
  'DR Congo': '🇨🇩',
  Ecuador: '🇪🇨',
  Egypt: '🇪🇬',
  England: '🏴󠁧󠁢󠁥󠁮󠁧󠁿',
  France: '🇫🇷',
  Germany: '🇩🇪',
  Ghana: '🇬🇭',
  Haiti: '🇭🇹',
  Iran: '🇮🇷',
  Iraq: '🇮🇶',
  'Ivory Coast': '🇨🇮',
  Japan: '🇯🇵',
  Jordan: '🇯🇴',
  Mexico: '🇲🇽',
  Morocco: '🇲🇦',
  Netherlands: '🇳🇱',
  'New Zealand': '🇳🇿',
  Norway: '🇳🇴',
  Panama: '🇵🇦',
  Paraguay: '🇵🇾',
  Portugal: '🇵🇹',
  Qatar: '🇶🇦',
  'Saudi Arabia': '🇸🇦',
  Scotland: '🏴󠁧󠁢󠁳󠁣󠁴󠁿',
  Senegal: '🇸🇳',
  'South Africa': '🇿🇦',
  'South Korea': '🇰🇷',
  Spain: '🇪🇸',
  Sweden: '🇸🇪',
  Switzerland: '🇨🇭',
  Tunisia: '🇹🇳',
  Turkey: '🇹🇷',
  USA: '🇺🇸',
  Uruguay: '🇺🇾',
  Uzbekistan: '🇺🇿',
};

// Nombre en español de las selecciones (para mostrar al hincha).
const ES: Record<string, string> = {
  Algeria: 'Argelia',
  Australia: 'Australia',
  Austria: 'Austria',
  Belgium: 'Bélgica',
  'Bosnia & Herzegovina': 'Bosnia',
  Brazil: 'Brasil',
  Canada: 'Canadá',
  'Cape Verde': 'Cabo Verde',
  Colombia: 'Colombia',
  Croatia: 'Croacia',
  'Czech Republic': 'Rep. Checa',
  'DR Congo': 'RD Congo',
  Ecuador: 'Ecuador',
  Egypt: 'Egipto',
  England: 'Inglaterra',
  France: 'Francia',
  Germany: 'Alemania',
  Ghana: 'Ghana',
  Haiti: 'Haití',
  Iran: 'Irán',
  Iraq: 'Irak',
  'Ivory Coast': 'Costa de Marfil',
  Japan: 'Japón',
  Jordan: 'Jordania',
  Mexico: 'México',
  Morocco: 'Marruecos',
  Netherlands: 'Países Bajos',
  'New Zealand': 'Nueva Zelanda',
  Norway: 'Noruega',
  Panama: 'Panamá',
  Paraguay: 'Paraguay',
  Portugal: 'Portugal',
  Qatar: 'Catar',
  'Saudi Arabia': 'Arabia Saudita',
  Scotland: 'Escocia',
  Senegal: 'Senegal',
  'South Africa': 'Sudáfrica',
  'South Korea': 'Corea del Sur',
  Spain: 'España',
  Sweden: 'Suecia',
  Switzerland: 'Suiza',
  Tunisia: 'Túnez',
  Turkey: 'Turquía',
  USA: 'Estados Unidos',
  Uruguay: 'Uruguay',
  Uzbekistan: 'Uzbekistán',
};

// Código ISO 3166-1 (alpha-2, o subdivisión para UK) para imágenes de bandera (flagcdn).
const ISO: Record<string, string> = {
  Algeria: 'dz', Argentina: 'ar', Australia: 'au', Austria: 'at', Belgium: 'be',
  'Bosnia & Herzegovina': 'ba', Brazil: 'br', Canada: 'ca', 'Cape Verde': 'cv',
  Colombia: 'co', Croatia: 'hr', 'Curaçao': 'cw', 'Czech Republic': 'cz', 'DR Congo': 'cd',
  Ecuador: 'ec', Egypt: 'eg', England: 'gb-eng', France: 'fr', Germany: 'de', Ghana: 'gh',
  Haiti: 'ht', Iran: 'ir', Iraq: 'iq', 'Ivory Coast': 'ci', Japan: 'jp', Jordan: 'jo',
  Mexico: 'mx', Morocco: 'ma', Netherlands: 'nl', 'New Zealand': 'nz', Norway: 'no',
  Panama: 'pa', Paraguay: 'py', Portugal: 'pt', Qatar: 'qa', 'Saudi Arabia': 'sa',
  Scotland: 'gb-sct', Senegal: 'sn', 'South Africa': 'za', 'South Korea': 'kr', Spain: 'es',
  Sweden: 'se', Switzerland: 'ch', Tunisia: 'tn', Turkey: 'tr', USA: 'us', Uruguay: 'uy',
  Uzbekistan: 'uz',
  'West Germany': 'de',
  Yugoslavia: 'rs',
  'Soviet Union': 'ru',
  'Czechoslovakia': 'cz',
};

export function flag(team: string): string {
  return FLAGS[team] ?? '⚽';
}

export function isoCode(team: string): string | null {
  return ISO[team] ?? null;
}

// URL de la imagen de bandera (PNG, ~alta resolución). null si no tenemos el código.
export function flagUrl(team: string, width = 160): string | null {
  const code = ISO[team];
  return code ? `https://flagcdn.com/w${width}/${code}.png` : null;
}

// Nombre para mostrar: español si lo tenemos; si no, el original (incluye placeholders).
export function teamName(team: string): string {
  return ES[team] ?? team;
}
